import { isDev } from 'helpers';
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './styles/index.scss';

const root = document.getElementById('arion-app-root');

if (root) {
	ReactDOM.createRoot(root).render(
		isDev() ? (
			<React.StrictMode>
				<App />
			</React.StrictMode>
		) : (
			<App />
		)
	);
} else {
	console.error('There is no "root" element.');
}
